<template>
  <section class="sidebar-layout">
    <div class="left">
      <el-menu default-active="2" class="el-menu-vertical-demo">
        <el-menu-item
          v-for="item in tabs"
          :index="item.routeName"
          :key="item.routeName"
          @click="handleTab(item)"
          :class="$route.path === item.path ? 'is-active' : ''"
        >
          <i class="el-icon-menu"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        {
          name: "案例管理",
          routeName: "EngineeringCaseList",
          path: "/engineering/case/list",
          disabled: false,
        },
        {
          name: "区域",
          routeName: "AreasList",
          path: "/engineering/case/areas/list",
          disabled: false,
        },
        {
          name: "设计方",
          routeName: "DesignersList",
          path: "/engineering/case/designers/list",
          disabled: false,
        },
        {
          name: "开发商",
          routeName: "DevelopersList",
          path: "/engineering/case/developers/list",
          disabled: false,
        },

        {
          name: "类型",
          routeName: "TypesList",
          path: "/engineering/case/types/list",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    handleTab(item) {
      this.$router.push({
        name: item.routeName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom-variables.scss";
.sidebar-layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .left {
    flex: 120px 0 0;
    height: 100%;
    background-color: #fff;
  }
  .right {
    flex: 1 0 0;
    height: 100%;
    overflow: hidden;
  }
}
.is-active {
  outline: none;
  background-color: #f1f1f1 !important;
  color: $custom-menu-hover-color !important;
}
</style>
